import { Controller } from "stimulus";

export default class extends Controller {

  setPrice(event) {
    var parentElem = $(event.target).closest('.js-price-rule-options');

    parentElem.find('.js-adjust-price-setting').hide();
    parentElem.find('.js-adjust-price-setting-to-currency').click();
  }

  notSetPrice(event) {
    var parentElem = $(event.target).closest('.js-price-rule-options');
    parentElem.find('.js-adjust-price-setting').show();
  }

  showCurrency(event) {
    var parentElem = $(event.target).closest('.js-price-rule-options');

    parentElem.find('.js-by-currency').show();
    parentElem.find('.js-by-percent').hide();
  }

  showPercent(event) {
    var parentElem = $(event.target).closest('.js-price-rule-options');

    parentElem.find('.js-by-currency').hide();
    parentElem.find('.js-by-percent').show();
  }

}